import { useEffect } from 'react'
import { useActor, useMachine } from '@xstate/react'
import dayjs from 'dayjs'
import styles from './MyTransactions.module.scss'
import { Loader } from '../Loader/Loader'
import { Pagination } from '../Pagination/Pagination'
import { Banners } from '../Banners/Banners'
import { NoData } from '../NoData/NoData'
import { myTransactionsMachine } from '../../xstate/mytransactions.machine'
import { AuthState } from '../../xstate/auth.machine'
import { Link } from 'react-router-dom'
import { Icon } from '../SVGsprite/svgsprite'

export function MyTransactions() {
	const [stateTransactions, sendTransactions] = useMachine(
		myTransactionsMachine
	)
	const [stateAuth] = useActor(AuthState)

	useEffect(() => {
		document.title = 'Мои баллы | Программа лояльности SK ZIC'
	}, [])

	console.log(stateTransactions)

	return (
		<>
			<section className={styles.workarea}>
				<div className='titleBlock'>
					<div className={styles.rowBalance}>
						<h1>Мои баллы</h1>
						<div className={styles.rowBalanceValue}>
							Всего:{' '}
							{new Intl.NumberFormat('ru-RU').format(stateAuth.context.balance)}{' '}
							баллов
						</div>
					</div>
					{(!['owner', 'distributor'].includes(stateAuth.context.type) ||
						stateAuth.context.subtype === 'dedicated_distributor') && (
						<Link to='/shop' className='btn btnPrimary btnIcon'>
							<Icon name='icon-add' sizeW='24' sizeH='24' />
							Заказать подарок
						</Link>
					)}
				</div>

				<div className='statContainer'>
					{stateTransactions.matches('loading') ? (
						<Loader />
					) : (
						<>
							<ReceiptsTable data={stateTransactions.context.list} />
							{stateTransactions.context.pages > 1 && (
								<Pagination
									pages={stateTransactions.context.pages}
									current_page={stateTransactions.context.current_page}
									send={sendTransactions}
								/>
							)}
						</>
					)}
				</div>
			</section>
			<aside className={styles.sidebar}>
				{/* <Bonuses/> */}
				<Banners />
			</aside>
		</>
	)
}

function ReceiptsTable(props) {
	if (props.data.length === 0) {
		return <NoData />
	}

	return (
		<div className='scrollbox'>
			<table className='statTable'>
				<thead>
					<tr>
						<th>Дата и время начисления/списания баллов</th>
						<th>За что начислено /списано</th>
						<th>Количество баллов</th>
					</tr>
				</thead>
				<tbody>
					{props.data.map(item => (
						<tr key={item.id}>
							<td>{dayjs(item.created_at).format('DD.MM.YY, HH:mm')}</td>
							<td>{item.description}</td>
							<td>{item.amount}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
